import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "celebi_cookie_consent";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch (_) {
      setShow(true);
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (_) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed z-[120] left-0 right-0 bottom-0 md:left-6 md:right-auto md:bottom-6 md:max-w-md"
    >
      <div className="glass-modal text-white p-6 md:rounded-md shadow-[0_30px_70px_-30px_rgba(0,0,0,0.85)] border-t md:border border-[#d9b877]/25">
        <div className="flex items-start gap-3 mb-3">
          <span className="w-9 h-9 shrink-0 rounded-full bg-[#b8893a]/20 flex items-center justify-center">
            <Cookie size={18} className="text-[#d9b877]" />
          </span>
          <div>
            <h3 className="font-display text-xl font-500 leading-tight">Çerez Kullanımı</h3>
            <p className="text-white/65 text-[13px] leading-relaxed mt-1.5 font-body">
              Deneyiminizi iyileştirmek için çerezler kullanıyoruz. Sitemizi
              kullanmaya devam ederek çerez politikamızı kabul etmiş olursunuz.{" "}
              <Link
                to="/cerez-politikasi"
                className="text-[#e7cf9c] underline underline-offset-2 hover:text-white"
                data-testid="cookie-policy-link"
              >
                Daha fazla bilgi
              </Link>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 mt-4 font-body">
          <button
            onClick={() => decide("accepted")}
            data-testid="cookie-accept-btn"
            className="btn-gold flex-1 py-3 rounded-sm"
          >
            Kabul Et
          </button>
          <button
            onClick={() => decide("rejected")}
            data-testid="cookie-reject-btn"
            className="flex-1 py-3 rounded-sm border border-white/25 text-white/80 hover:bg-white/10 transition-colors text-[0.78rem] uppercase tracking-[0.14em]"
          >
            Reddet
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
